export default {
    namespaced: true,

    state: {
        metrics: {
            accuracyRate: 0,
            accuracyGrowthPercentage: 0,
            messagesReviewedLast30Days: 0,
            interventionRate: 0,
            interventionGrowthPercentage: 0
        },
        loading: false,
        metricsRequestId: 0
    },

    mutations: {
        setMetrics (state, payload) {
            state.metrics = payload
        },
        setLoading (state, payload) {
            state.loading = payload
        },
        startMetricsRequest (state) {
            state.metricsRequestId += 1
            state.loading = true
        }
    },

    actions: {
        async fetchMetrics ({ commit, state }, { curationService, startDate, endDate }) {
            commit('startMetricsRequest')
            const requestId = state.metricsRequestId

            try {
                const response = await curationService.getGeneralMetrics(startDate, endDate)

                if (state.metricsRequestId === requestId && response && response.data) {
                    commit('setMetrics', response.data)
                }
            } catch (error) {
                console.error('Erro ao carregar métricas de curadoria:', error)
                throw error
            } finally {
                if (state.metricsRequestId === requestId) {
                    commit('setLoading', false)
                }
            }
        }
    },

    getters: {
        metrics: state => state.metrics,
        loading: state => state.loading,
        accuracyRate: state => state.metrics.accuracyRate,
        interventionRate: state => state.metrics.interventionRate
    }
}
